export default {
    key: 'swa',
    common: {
        productName: 'core.productNames.swa',
        splashMessage: 'offerFlow.splashMessage.swa',
        headingAside: 'offerFlow.headingAside.swa',
    },
    stepActivitySelection: {
        heading: 'offerFlow.pages.stepActivitySelection.heading.common',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.swa',
    },
    stepActivityOptions: {
        heading: 'offerFlow.pages.stepActivityOptions.heading.common',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.activity',
        body: 'offerFlow.pages.stepPassengers.body.common',
    },
} satisfies OfferFlowContent;
